import PropTypes from 'prop-types';
import React from 'react';
import RadioFieldGroup from 'components/shared/RadioFieldGroup/';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';
import HeaderImage from './HeaderImage';
import { HeaderStyle } from './types';

const HeaderDesigns = ({
  availableDesigns,
  selectedDesign,
  updateLearnHeaderStyle,
}) => {
  return (
    <RadioFieldGroup
      className="ff-ss mt-12"
      selectedValue={selectedDesign}
      name="type"
      onChange={updateLearnHeaderStyle}
    >
      {Object.keys(availableDesigns).map(headerDesign => (
        <RadioField className="c-p" value={headerDesign} key={headerDesign}>
          {availableDesigns[headerDesign]}
          <HeaderImage headerDesign={headerDesign} />
        </RadioField>
      ))}
    </RadioFieldGroup>
  );
};

HeaderDesigns.propTypes = {
  availableDesigns: PropTypes.objectOf(PropTypes.string),
  selectedDesign: HeaderStyle,
  updateLearnHeaderStyle: PropTypes.func,
};

export default HeaderDesigns;
